import { Videocam } from "@mui/icons-material";
import React, { memo } from "react";

import { getBackendUrl } from "../../../config";
import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();
  const link = getBackendUrl();

  return (
    <NodeCard color="#0891b2" icon={<Videocam />} title="Vídeo" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <video controls="controls" className={classes.media}>
        <source src={`${link}/public/${data.url}`} type="video/mp4" />
        seu navegador não suporta HTML5
      </video>
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
